import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, Search } from 'lucide-react';
import { motion } from 'framer-motion';

const tools = [
  { name: 'Calculadora', path: '/utils/calculator' },
  { name: 'Gerador de Senha', path: '/utils/password' },
  { name: 'Conversor de Moeda', path: '/converters/currency' },
  { name: 'Validador de Email', path: '/security/email' },
  { name: 'Validador de CPF', path: '/security/cpf' },
  { name: 'Validador de CNPJ', path: '/security/cnpj' },
  { name: 'Conversor de Cor', path: '/converters/colors' },
  { name: 'Verificador de DNS', path: '/domains/dns' },
  { name: 'Verificador de SSL', path: '/domains/ssl' },
  { name: 'Gerador de QR Code', path: '/images/qr' },
  { name: 'Tempo de Resposta', path: '/domains/response' },
  { name: 'Consulta de MAC Address', path: '/utils/mac-lookup' }, 
];

const Header = ({ onMenuClick, category, tool }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    if (category && tool) return `${category}: ${tool}`;
    if (category) return category;
    const path = location.pathname;
    if (path === '/') return 'Dashboard';
    if (path.startsWith('/utils')) return 'Utilidades';
    if (path.startsWith('/converters')) return 'Conversores';
    if (path.startsWith('/security')) return 'Segurança';
    if (path.startsWith('/content')) return 'Conteúdo';
    if (path.startsWith('/domains')) return 'Domínios';
    if (path.startsWith('/images')) return 'Imagens';
    if (path.startsWith('/text')) return 'Texto';
    if (path.startsWith('/development')) return 'Desenvolvimento';
    return 'nServers Tools';
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200 shadow-sm">
      <div className="flex items-center justify-between px-4 py-3 lg:px-6">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors lg:hidden"
          >
            <Menu size={20} />
          </button>
          
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">PT</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-semibold text-gray-900">nServers Tools</h1>
              <p className="text-xs text-gray-500">Ferramentas Online</p>
            </div>
          </Link>
        </div>

        <div className="hidden md:block">
          <motion.h2
            key={location.pathname}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-lg font-medium text-gray-900"
          >
            {getPageTitle()}
          </motion.h2>
        </div>

        <div className="flex items-center space-x-2">
          {/* Campo de busca removido */}
        </div>
      </div>

      <div className="sm:hidden px-4 pb-3">
        {/* Campo de busca mobile removido */}
      </div>
    </header>
  );
};

export default Header; 